
import React, { useState, useEffect, useContext } from "react";
import Header from "./Header";
// import Header from "../components/dashboard/header";

import Footer from "./Footer";
import sessionbg from '../assets/images/session-bg.svg';
import whoweare1 from '../assets/images/who-we-are-img1.png';
import whoweare2 from '../assets/images/who-we-are-img2.png';
import ourVision from '../assets/images/ourVision.svg';
import whychooseus from '../assets/images/why-choose-us-left.png';
import whychooseusright from '../assets/images/why-choose-us-right.png';
import excellence from '../assets/images/Star-Badge--Streamline-Core.svg';
import experienceexperts from '../assets/images/Ai-Technology-Spark--Streamline-Core.svg';
import labreporticon from '../assets/images/business-handshake--deal-contract-business-money-payment-agreement.svg';
import responsiveicon from '../assets/images/No-Poverty--Streamline-Core.svg';
import team2 from '../assets/images/team-2.png';
import team1 from '../assets/images/team-1.png';
import team3 from '../assets/images/team-3.png';
import stethoscope from '../assets/images/stethoscope.svg';
import premiumbadge from '../assets/images/premium-badge.svg';
// import ourValue from '../assets/images/our-value-bg.svg';
import sasiKiran from '../assets/images/Dr.Sasi-Kiran-Attili.svg';




const About = () => {

    useEffect(() => {
        window.scrollTo(0, 0);

    }, []);



    return (
        <>
            <Header />

            <section className="about-us-section">
                <div className="container">
                    <h3 className="txt-48">About</h3>
                    <p className="txt-16">Precision Diagnostics. Lifelong Learning. Global Impact.</p>
                </div>
            </section>



            <section className="who-we-are-section">
                <div className="we-are_bg">
                    <img src={sessionbg} alt="DADI Logo" width="1130" />
                </div>

                <div className="container about-txt-img">
                    <div className="left-section">
                        <p className="txt-16">About Us</p>
                        <h3 className="txt-48">Who We Are</h3>
                        <p className="txt-22">
                            We are a virtual dermatopathology platform committed to delivering expert diagnostic services and providing cutting-edge educational resources to clinicians, students, and dermatopathology enthusiasts worldwide.
                        </p>
                        <p className="txt-22">
                            Founded by a team of board-certified dermatopathologists and seasoned educators, we bring a combined passion for precision medicine, innovation, and mentorship. Every service we offer is designed to improve patient outcomes and support professional growth.
                        </p>
                    </div>
                    <div className="right-section">
                        <img src={whoweare1} className="doctor-group" alt="Doctor Group" />
                        <img src={whoweare2} className="microscope" alt="Microscope" />
                    </div>
                </div>

                <div className="vision-section">
                    <div className="image-container">
                        <img src={ourVision} alt="Doctors Vision" />
                    </div>
                    <div className="vision-text">
                        <h3 className="txt-48">Our Vision</h3>
                        <p className="txt-22">
                            To become the leading global platform where dermatopathology diagnostics and education meet,
                            empowering healthcare providers and learners to deliver better care through knowledge and expertise.
                        </p>
                    </div>
                </div>
            </section>


            <section className="our-values-section">
                <img src={whychooseus} className="our-values-left" />
                <img src={whychooseusright} className="our-values-right" />
                <div className="container">
                    <h3 className="txt-48">Our Values</h3>
                    <div className="row mt-5">

                        <div className="col-lg-6 col-md-6 value-box">
                            <div className="value-box-item">
                                <div className="value-icon">
                                    <img src={excellence} alt="Excellence" width="40" />
                                </div>
                                <div className="value-content">
                                    <h1 className="value-title">Excellence</h1>
                                    <p className="value-description">Commitment to the highest standards in<br />diagnostics and teaching</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-6 col-md-6 value-box">
                            <div className="value-box-item">
                                <div className="value-icon">
                                    <img src={experienceexperts} alt="Excellence" width="40" />
                                </div>
                                <div className="value-content">
                                    <h1 className="value-title">Innovation</h1>
                                    <p className="value-description">Leveraging technology to enhance<br />accessibility and learning</p>
                                </div>
                            </div>
                        </div>


                        <div className="col-lg-6 col-md-6 value-box res-margin">
                            <div className="value-box-item">
                                <div className="value-icon">
                                    <img src={labreporticon} alt="Excellence" width="40" />
                                </div>
                                <div className="value-content">
                                    <h1 className="value-title">Integrity</h1>
                                    <p className="value-description">Maintaining trust, transparency, and<br />accuracy in everything we do</p>
                                </div>
                            </div>
                        </div>


                        <div className="col-lg-6 col-md-6 value-box res-margin">
                            <div className="value-box-item">
                                <div className="value-icon">
                                    <img src={responsiveicon} alt="Excellence" width="40" />
                                </div>
                                <div className="value-content">
                                    <h1 className="value-title">Community</h1>
                                    <p className="value-description"> Building a strong, supportive network of<br />clinicians and learners</p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>


            <section className="meet-our-team-section">
                <div className="container">
                    <h3 className="txt-48 mb-5">Meet Our Team</h3>

                    {/* Dr. Manoj K. Singh */}
                    <div className="team-card d-flex">
                        <div className="image-wrapper left-txt">
                            <div className="image-circle">
                                <img src={team2} alt="Dr. Manoj K. Singh" className="profile-img" />
                            </div>
                        </div>
                        <div className="right-txt">
                            <div>
                                {/* <p className="txt-16">MD (Pathology), FRCPath</p> */}
                                <h3>Dr. Manoj K. Singh</h3>
                            </div>
                            <div className="d-flex gap-2 mb-4 mt-4">
                                <span className="badge-custom">
                                    <img src={stethoscope} width="24" alt="Stethoscope Icon" />
                                    <span className="mx-2">30+ Years</span>
                                </span>
                                <span className="badge-award">
                                    <img src={premiumbadge} width="24" alt="Award Icon" />
                                    <span className="mx-2">Dr. B. C. Roy National Award</span>
                                </span>
                            </div>
                             <h6 className="about-us-team-sub-head mb-2">
                                Senior Academic & Diagnostic Leadership 
                            </h6>
                            <div>
                                <ul className="team-list">
                                    <li className="fw-bold">MD (Pathology); FRCPath </li>
                                    <li className="fw-bold">Former Professor & Head, Department of Pathology, AIIMS </li>
                                    <li className="fw-bold">Former Director, Dermatopathology Laboratory, AIIMS </li>
                                    <li className="fw-bold">Consultant Dermatopathologist, Lifeline Laboratory & Agilus Diagnostic Network, Delhi </li>
                                </ul>
                            </div>
                            <h6 className=" mb-2">
                                Pioneer of dermatopathology in India with over three decades of academic leadership.
                            </h6>
                            <div>
                                <ul className="team-list">
                                    <li>Instrumental in establishing organised dermatopathology services and training at AIIMS </li>
                                    <li>Recipient of the Dr. B. C. Roy National Award  </li>
                                    <li>Author of 130+ peer-reviewed publications </li>
                                    <li>National authority in dermatopathology education and quality assurance  </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    {/* Dr. G. Nandakumar */}
                    <div className="team-card d-flex mt-4">
                        <div className="image-wrapper left-txt">
                            <div className="image-circle">
                                <img src={team1} alt="Dr. G. Nandakumar" className="profile-img" />
                            </div>
                        </div>
                        <div className="right-txt">
                            <div>
                                {/* <p className="txt-16">MD (D&V), MD (Pathology)</p> */}
                                <h3>Dr. G. Nandakumar</h3>
                            </div>
                            <div className="d-flex gap-2 mb-4 mt-4">
                                <span className="badge-custom">
                                    <img src={stethoscope} width="24" alt="Stethoscope Icon" />
                                    <span className="mx-2">30+ Years</span>
                                </span>
                                <span className="badge-award">
                                    <img src={premiumbadge} width="24" alt="Award Icon" />
                                    <span className="mx-2">IADVL Best Teacher Award (2024)</span>
                                </span>
                            </div>
                               <h6 className="about-us-team-sub-head mb-2">
                                Clinical & Teaching Leadership  
                            </h6>
                            <div>
                                <ul className="team-list">
                                    <li className="fw-bold">MD (D&V); MD (Pathology) </li>
                                    <li className="fw-bold">Former Principal & Head, Department of Pathology, Government Medical College, Trivandrum  </li>
                                    <li className="fw-bold">Senior Consultant, Dermatology & Dermatopathology, Cosmopolitan Hospital, Trivandrum, Kerala </li>
                                    <li className="fw-bold">Recipient, IADVL Best Teacher Award (2024)  </li>
                                </ul>
                            </div>
                            <h6 className="mb-2">
                                Uniquely dual-trained dermatologist and pathologist with a distinguished academic career. 
                            </h6>
                            <div>
                                <ul className="team-list">
                                    <li>Widely respected for postgraduate teaching and clinicopathological correlation </li>
                                    <li>Academic interests include inflammatory dermatoses, adnexal tumours, and dermatopathology education   </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    {/* Dr. Sasi Kiran Attili */}
                    <div className="team-card d-flex mt-4">
                        <div className="image-wrapper left-txt">
                            <div className="image-circle">
                                <img src={sasiKiran} alt="Dr. Sasi Kiran Attili" className="profile-img" />
                            </div>
                        </div>
                        <div className="right-txt">
                            <div>
                                <h3>Dr. Sasi Kiran Attili</h3>
                                {/* <p className="txt-16">MRCP (Dermatology, UK), ICDP–UEMS</p> */}
                            </div>
                            <div className="d-flex gap-2 mb-4 mt-3">
                                <span className="badge-custom">
                                    <img src={stethoscope} width="24" alt="Stethoscope Icon" />
                                    <span className="mx-2">20+ Years</span>
                                </span>
                                <span className="badge-award">
                                    <img src={premiumbadge} width="24" alt="Award Icon" />
                                    <span className="mx-2">Editor-in-Chief, IJDDD</span>
                                </span>
                            </div>
                                <h6 className="about-us-team-sub-head mb-2">
                                Academic & Mentorship Leadership 
                            </h6>
                            <div>
                                <ul className="team-list">
                                    <li className="fw-bold">MRCP (Dermatology, UK); ICDP–UEMS   </li>
                                    <li className="fw-bold">Consultant Dermatologist & Dermatopathologist </li>
                                    <li className="fw-bold">Editor-in-Chief, Indian Journal of Dermatopathology & Diagnostic Dermatology  </li>
                                </ul>
                            </div>
                            <h6 className="mb-2">
                               UK-trained dermatologist–dermatopathologist with a strong academic focus on clinicopathological correlation and diagnostic reasoning. 
                            </h6>
                            <div>
                                <ul className="team-list">
                                    <li>Delivered 150+ national and international academic presentations  </li>
                                    <li>Developed structured dermatopathology teaching frameworks </li>
                                    <li>Initiated national quiz programmes and digital CPC platforms  </li>
                                    <li>Leads digital architecture, website development, and institutional partnerships for DADI  </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
        </>
    )
}

export default About;
